// extracted by mini-css-extract-plugin
module.exports = {"bodywrapper":"about_bodywrapper__ykgi_","page-title":"about_page-title__1AktG","watermark":"about_watermark__1Ds30"};